import React from 'react';
import {useFormikContext} from 'formik';
import {useLocation} from 'react-router-dom';

import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {parseQueryString} from 'shared/utils';
import {getScoresByTestType} from 'shared/portfolio/actions/test-scores';
import {TestScoreForm, TestScoreType} from './test-scores-form-wrapper';

import FormikDropdown from 'src/components/formik-dropdown';
import Label from 'shared/components/label';

const TEST_TYPES = [
  {value: 'psat2015', text: 'PSAT'},
  {value: 'sat2016', text: 'SAT'},
  {value: 'preAct', text: 'PreACT'},
  {value: 'act2025', text: 'ACT'},
  {value: 'act', text: 'Legacy ACT'},
  {value: 'ap', text: 'AP'},
  {value: 'other', text: 'Other'},
];

const TestTypeSelector = () => {
  const mq = useMediaQuery();
  const formik = useFormikContext<TestScoreForm>();
  const location = useLocation();
  const {tests} = parseQueryString(location.search.slice(1));
  const testsArray = tests?.split(',') || [];

  return (
    <Label required>
      Select a test to add your score
      <FormikDropdown
        name="type"
        options={
          location.pathname.includes('/test-score/new') && testsArray.length
            ? TEST_TYPES.filter(({value}) => testsArray.includes(value))
            : TEST_TYPES
        }
        onChange={(e) => {
          formik.setValues({
            ...formik.values,
            scores: getScoresByTestType(mq.MS_AND_DOWN)[e.target.value],
            type: e.target.value as TestScoreType,
          });
        }}
        required
      />
    </Label>
  );
};

export default TestTypeSelector;
